import type { BaseTeam } from "@redotech/account-common/base-team";
import type { RedoMerchantRpcClient } from "@redotech/merchant-sdk/rpc/client";
import { RECLAIM_INSTALL_APP_PROMPT_DEFER_SETTING_KEY } from "./constants";
import { getReclaimInstallAppPromptDeferredUntil } from "./eligibility";

type UpdatePickedSettings = RedoMerchantRpcClient["updatePickedSettings"];

interface ReclaimInstallAppPromptRpcClient {
  updatePickedSettings: (
    input: Parameters<UpdatePickedSettings>[0],
  ) => ReturnType<UpdatePickedSettings>;
}

export async function deferReclaimInstallAppPrompt({
  rpcClient,
  teamId,
  now = new Date(),
}: {
  rpcClient: ReclaimInstallAppPromptRpcClient;
  teamId: BaseTeam["_id"];
  now?: Date;
}): Promise<Date> {
  const deferredUntil = getReclaimInstallAppPromptDeferredUntil(now);
  const result = await rpcClient.updatePickedSettings({
    teamId,
    settings: { [RECLAIM_INSTALL_APP_PROMPT_DEFER_SETTING_KEY]: deferredUntil },
  });

  if (!result.success) {
    throw new Error("Failed to defer Reclaim app install prompt");
  }

  return deferredUntil;
}
